import {Component, inject, model, OnInit, ViewChild} from '@angular/core';
import {NgIf, SlicePipe} from "@angular/common";
import {CustomErrorComponent} from "../../../../shared/commons/custom-error.component";
import {FormsModule, NgForm} from "@angular/forms";
import {GtNgDatepickerModule} from "../../../../shared/commons/gt-ng-datepicker/gt-ng-datepicker.module";
import {NotFoundComponent} from "../../../../shared/not-found/not-found.component";
import {RightSearchResource} from "../../../../service/RightSearchResource";
import {RightSearchDto, RightSearchPageData, Source} from "../../../../../generated-model/model";
import {updateFormAndValidity} from "../../../../app.constants";
import {SharedCommonModule} from "../../../../shared/commons/shared-common.module";
import {ActivatedRoute, Router, RouterLink} from "@angular/router";
import {BtnLk2Component} from "../../../../shared/components/btn-lk2/btn-lk2.component";
import {BirthdateWithoutDate} from "../../../../shared/birthdate-without-date";

@Component({
  selector: 'app-right-search-by-name',
  standalone: true,
  imports: [
    CustomErrorComponent,
    FormsModule,
    GtNgDatepickerModule,
    NgIf,
    NotFoundComponent,
    SharedCommonModule,
    RouterLink,
    SlicePipe,
    BtnLk2Component,
    BirthdateWithoutDate
  ],
  templateUrl: './right-search-by-name.component.html',
  styleUrl: './right-search-by-name.component.scss'
})
export class RightSearchByNameComponent implements OnInit {
  @ViewChild("form", {read: NgForm, static: true}) form: NgForm;
  checkRightsResource = inject(RightSearchResource);
  dataList: RightSearchPageData[] = [];
  router = inject(Router);
  activatedRoute = inject(ActivatedRoute);
  firstName: string;
  lastName: string;
  page: number = 0;
  pageSize: number = 20;
  source = model<Source>();

  constructor() {

  }

  ngOnInit(): void {
    console.log('history: ', history.state);
    this.page = history.state.page || this.page;
    this.dataList = history.state.dataList || [];
    this.source.set('NHSO');

    // this.firstName = 'สุภาพร';
    // this.lastName = 'แซ่ลิ้ม';
    // this.search();
  }

  search() {
    let formValid = updateFormAndValidity(this.form);
    if (formValid) {
      this.checkRightsResource.findByName(this.firstName, this.lastName)
        .subscribe(value => {
          this.dataList = value;
          history.pushState({dataList: this.dataList}, undefined);
        });
    }
  }

  checkRights(item: RightSearchDto) {
    this.router.navigate([item.personalId, 'detail'], {
      queryParams: {firstName: item.firstName, lastName: item.lastName, source: this.source()},
      // state: this.dataList,
      relativeTo: this.activatedRoute
    });
  }

  pageChange() {
    history.pushState({...history.state, page: this.page}, undefined);
  }

  ngOnDestroy(): void {
  }
}
